
(function($){
    // JS
    window.Filter = {

        // Filter the regions on our partners page
        //======================================================================
        loadRegions: function()
        {
        $(document).ready(function(){

           $(document).on('click', '[data-js-flag]', function(e){
                e.preventDefault();

                var category = $(this).data('js-flag');

                var loader = $('.loader');
                var regions = $('.regions');
                loader.fadeIn();
                regions.fadeOut();
                

                $.ajax({
                    url: wpAjax.ajaxUrl,
                    data: {action: 'filter', category: category},
                    type: 'post',
                    success: function(result) {
                        $('.js-regions').html(result);
                        loader.fadeOut();
                        regions.fadeIn();
                    },
                    error: function(result) {
                        console.warn(result);
                    }
                });

            });
        });
            
        },
        // filter by date and category
        filterPressReleases: function() {
            $(document).on('change', '[data-js-form=filter_press]', function(e){
                e.preventDefault();
                var data = $(this).serialize();

                var loader = $('.loader');
                var press = $('.press-releases-container');
                loader.fadeIn();
                press.fadeOut();

                $.ajax({
                    url: wpAjax.ajaxUrl,
                    data: data,
                    type: 'post',
                    success: function(result) {
                        $('.press-releases-container').html(result);
                        loader.fadeOut();
                        press.fadeIn();
                    },
                    error: function(result) {
                        console.warn(result);
                    }
                });
            });
        },
        filterEvents: function() 
        {
            $(document).on('click', '[data-js-event]', function(e){
                e.preventDefault();

                var all = $('[data-js-event]');

                console.log($(this).data('js-event'));

                var type = $(this).data('js-event');

                all.removeClass('current');
                $(this).addClass('current');
                

                var loader = $('.loader');
                var events = $('.events');
                loader.fadeIn();
                events.fadeOut();
                

                $.ajax({
                    url: wpAjax.ajaxUrl,
                    data: {action: 'filter_event', type: type},
                    type: 'post',
                    success: function(result) {
                        console.log(result);
                        $('.events').html(result);
                        loader.fadeOut();
                        events.fadeIn();
                    },
                    error: function(result) {
                        console.warn(result);
                    }
                });

            });
        }
    }

    // Run
    $(function(){
        Filter.loadRegions();
        Filter.filterPressReleases();
        Filter.filterEvents();
    });


}(jQuery));